var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShekelIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.85771 3.42885V10.2866H8.57214V3.42885C8.57214 1.53784 7.0343 0 5.14328 0H0V13.7154H1.71443V1.71443H5.14328C6.08879 1.71443 6.85771 2.48335 6.85771 3.42885Z",
    fill: "#586A84"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2854 10.2866C10.2854 11.2321 9.51652 12.001 8.57102 12.001H5.14216V3.42885H3.42773V13.7154H8.57102C10.462 13.7154 11.9999 12.1776 11.9999 10.2866V0H10.2854V10.2866Z",
    fill: "#586A84"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShekelIcon);
export default __webpack_public_path__ + "static/media/shekel-icon.d67ac14c91f0045f60aa41a609d4f63c.svg";
export { ForwardRef as ReactComponent };